import { render, staticRenderFns } from "./majorYxzyz.vue?vue&type=template&id=c9841c8c&scoped=true&"
import script from "./majorYxzyz.vue?vue&type=script&lang=js&"
export * from "./majorYxzyz.vue?vue&type=script&lang=js&"
import style0 from "./majorYxzyz.vue?vue&type=style&index=0&id=c9841c8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9841c8c",
  null
  
)

export default component.exports